//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const getChipType = (chipType: string) => {
  switch (chipType) {
    case 'trending-up':
      return 'success';
    case 'trending-down':
      return 'error';
    default:
      return 'default';
  }
};
